const OPERATING_COMPANIES = [
  {
    id: "shivshankar",
    name: "Shivshankar Logistics",
    shortName: "Shivshankar",
    responsibility: "Road transportation and rail operations",
    invoiceSeries: "SSL/26-27",
    gstin: "27AAAAA0000A1Z5",
  },
  {
    id: "mark-merc",
    name: "Mark or Merc Logistics",
    shortName: "Mark/Merc",
    responsibility: "Ship and vessel movement",
    invoiceSeries: "MML/26-27",
    gstin: "27BBBBB0000B1Z5",
  },
  {
    id: "world-trans",
    name: "World Trans",
    shortName: "World Trans",
    responsibility: "Market orders and customer acquisition",
    invoiceSeries: "WT/26-27",
    gstin: "27CCCCC0000C1Z5",
  },
  {
    id: "geo-logistics",
    name: "Geo Logistics",
    shortName: "Geo Logistics",
    responsibility: "Market orders and customer acquisition",
    invoiceSeries: "GL/26-27",
    gstin: "27DDDDD0000D1Z5",
  },
];
const SYSTEM_CUSTOMER_NAME = "GPS WALA consolidated transport group";
export { OPERATING_COMPANIES, SYSTEM_CUSTOMER_NAME };
